import { Box, useTheme } from "@mui/material";
import type { FC } from "react";

const TOP_GLOW_HEIGHT = 200;

export const MyPlannTopGlow: FC = () => {
	const theme = useTheme();

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			right={0}
			height={TOP_GLOW_HEIGHT}
			zIndex={-1}
			sx={{
				background: theme.gradients.dashboardSkyGlow,
				pointerEvents: "none",
			}}
		/>
	);
};
